"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkbox = void 0;
const colors_1 = require("./colors");
const spacings_1 = require("./spacings");
exports.checkbox = {
    states: {
        enabled: {
            borderColor: colors_1.colors.neutral.colorDark,
            '&:hover': {
                borderColor: colors_1.colors.brandcolor.primaryLightest,
            },
        },
        checked: {
            borderColor: colors_1.colors.brandcolor.primaryMedium,
            backgroundColor: colors_1.colors.brandcolor.primaryMedium,
        },
        error: {
            borderColor: colors_1.colors.feedbackError.colorMedium,
        },
        partial: {
            borderColor: colors_1.colors.brandcolor.primaryMedium,
            backgroundColor: colors_1.colors.brandcolor.primaryLightest,
        },
        disabled: {
            borderColor: colors_1.colors.neutral.colorMedium,
        },
        checkedDisabled: {
            borderColor: colors_1.colors.neutral.colorMedium,
            backgroundColor: colors_1.colors.neutral.colorMedium,
        },
        partialDisabled: {
            borderColor: colors_1.colors.neutral.colorMedium,
            backgroundColor: colors_1.colors.neutral.colorLight,
        },
    },
    sizes: {
        small: {
            width: `${spacings_1.spacings.layout.spacing2xs}`,
            height: `${spacings_1.spacings.layout.spacing2xs}`,
        },
        medium: {
            width: `${spacings_1.spacings.layout.spacingXs}`,
            height: `${spacings_1.spacings.layout.spacingXs}`,
        },
        large: {
            width: `${spacings_1.spacings.layout.spacingSm}`,
            height: `${spacings_1.spacings.layout.spacingSm}`,
        },
    },
};
//# sourceMappingURL=checkbox.js.map